import { useLingui } from '@lingui/react';
import { Flex, Group, Text } from '@mantine/core';
import { SignUpButton } from '../Shares/SignUpButton';
import { SocialMenuItem } from './SocialMenuItem';
export const SocialMenu: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Flex h="20%" gap={8} right={30} bottom={10} justify="end" pos="absolute" visibleFrom="sm" align={{
    base: 'end',
    md: 'center'
  }} direction={{
    base: 'column',
    md: 'row'
  }}>
      <SignUpButton />
      <Text c="dark" fw={700} fz="sm" visibleFrom="md">
        {i18n._('OR')}
      </Text>
      <Text hiddenFrom="md" c="dark" fw={700} fz="sm" tt="uppercase">
        {i18n._('Sign up now or')}
      </Text>
      <Group gap={8} align="center">
        <SocialMenuItem icon="icon-pr-flat-google" />
        <SocialMenuItem icon="icon-pr-flat-telegram" />
        <SocialMenuItem icon="icon-pr-flat-steam" />
        <SocialMenuItem icon="icon-pr-flat-twitch" />
      </Group>
    </Flex>;
};